import axios from "axios";
import { ContatoType } from "models/contato_type";
import { PessoaType } from "models/person_type";
import {
  Project,
  ProjectCategory,
  ProjectCategoryItem
} from "models/project_type";
import { UsuarioModel } from "models/user_model";
import { useEffect, useState } from "react";

const useProject = () => {
  const [list1, setList] = useState<Project[]>([]);
  const [usuario, setUsuario] = useState<UsuarioModel>();
  const [users, setUsers] = useState<UsuarioModel[]>([]);
  const [selectedOrder1, setSelectedOrder] = useState<Project>(null);
  const [show1, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initialProject, setInitialProject] = useState(false);
  const [clients, setClientes] = useState<PessoaType[]>([]);
  const [contatoCliente1, setContatoCliente] = useState<ContatoType>(null);
  const [contatoAgencia1, setContatoAgencia] = useState<ContatoType>(null);

  const showModal1 = async (show: boolean, item: Project) => {
    if (show) {
      loadItens(item);
      if (item?.Orcamento?.contatoAgencia) {
        await loadAgencia(item?.Orcamento?.contatoAgencia);
      }
      if (item?.Orcamento?.contatoCliente) {
        await loadClient(item?.Orcamento?.contatoCliente);
      }
    } else {
      setSelectedOrder(null);
    }
    setShow(show);
  };

  const loadItens = (item: Project) => {
    if (item.ProjetoCategoria.length > 0) {
      setSelectedOrder(item);
    } else {
      const newProject: Project = {
        ...item,
        ProjetoCategoria: item.Orcamento.OrcamentoCategoria.map((value) => {
          const projectCategory: ProjectCategory = {
            aprovado: false,
            descricao: value.descricao,
            executado: 0,
            metaReducao: 0,
            orcado: 0,
            projetoId: item.id,
            trabalhado: 0,
            travado: false,
            valor: value.valor,
            porcentagemManejo: "",
            porcentagemReducao: "",
            valorManejo: "0",
            valorReducao: "0",
            id: "",
            ProjetoItem: value.OrcamentoItem.map((val) => {
              const projectItem: ProjectCategoryItem = {
                id: "",
                projetoCategoriaId: "",
                produtoId: val.produtoId,
                descricao: val.descricao,
                unidadeMedidaId: val.unidadeMedidaId,
                quantidade: val.quantidade,
                valorUn: val.valorUn,
                valorTotal: val.valorTotal,
                orcado: 0,
                trabalhado: 0,
                executado: 0,
                usuarioId: usuario.id,
                aprovado: false,
                metaReducao: 0,
                travado: false,
                produtoNome: val.produtoNome,
                produtoUnidade: val.produtoUnidade,
                produtoUnidadeId: val.produtoUnidadeId,
                unidadeNome: val.unidadeNome,
                porcentagemManejo: "",
                porcentagemReducao: "",
                valorManejo: "0",
                valorReducao: "0",
              };
              return projectItem;
            }),
          };
          return projectCategory;
        }),
      };
      setSelectedOrder(newProject);
      setInitialProject(true);

    }
  };

  const loadContact = async (id: string) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/projeto/contato/" + id
    );
    if (response.data) {
      return response.data;
    }
  };

  const loadAgencia = async (id: string) => {
    const ca = await loadContact(id);
    if (ca) {
      setContatoAgencia(ca);
    }
  };
  const loadClient = async (id: string) => {
    const cl = await loadContact(id);
    if (cl) {
      setContatoCliente(cl);
    }
  };

  const loadUsers = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/user/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setUsers(response.data);
    }
  };

  const loadClients = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/pessoa/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setClientes(response.data);
    }
  };


  useEffect(() => {
    const loadOrder = async () => {
      const userData = JSON.parse(localStorage.getItem("user"));
      setUsuario(userData);
      const url = process.env.REACT_APP_API_URL + `/projeto/list/${userData?.idEmpresa}`;
      const response = await axios.get(url);
      if (response.data) {
        setList(response.data);
      }
    };
    const loadData = async () => {
      await loadOrder();
      await loadUsers();
      await loadClients();
    };
    loadData();
  }, []);

  return {
    list1,
    usuario,
    selectedOrder1,
    show1,
    loading,
    showModal1,
    contatoCliente1,
    contatoAgencia1,
    users,
    clients
  };
};
export default useProject;
